module.exports = __webpack_public_path__ + "static/media/news-en.471d33cc.webp";